import { useCallback } from 'react';

import { fg } from '@confluence/feature-gating';

export type DatabaseFeatureGate = 'dbAiFirstCreation';

export const useIsDatabaseFeatureEnabled = (): {
	isDatabaseFeatureEnabled: (featureName: DatabaseFeatureGate) => boolean;
} => {
	const isDatabaseFeatureEnabled = useCallback((featureName: DatabaseFeatureGate): boolean => {
		if (featureName === 'dbAiFirstCreation') {
			// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
			return fg('aifc_create_enabled_ga');
		}
		return false;
	}, []);

	return {
		isDatabaseFeatureEnabled,
	};
};
